import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/modeloFormulario/importer/modeloFormularioImporterActions';

export default importerReducers(actions);
